export const IMAGE_ASPECT_RATIO = 0
export const MIN_IMAGES_TO_SHOW = 4
